var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"navigation-panel"},_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.icon,class:route.activeClass,attrs:{"to":route.route,"tag":"li"}},[(route.icon)?_c(route.icon,{tag:"component"}):_vm._e(),_c('span',[_vm._v(_vm._s(route.label))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }